import { toggleSwitchDriverFactory as toggleSwitchCoreDriverFactory } from './ToggleSwitchCore/ToggleSwitchCore.driver';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

const toggleSwitchDriverFactory = ({ element, eventTrigger }) => {
  deprecationTestkitLog(
    'toggleSwitchTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the ToggleSwitchTestkit unidriver testkit instead.',
  );

  const coreToggleSwitchDriver = toggleSwitchCoreDriverFactory({
    element,
    eventTrigger,
  });

  return {
    ...coreToggleSwitchDriver,
    /** Get Toggle Switch size */
    getSize: () => element.getAttribute('data-size'),

    /** Get Toggle Switch skin */
    getSkin: () => element.getAttribute('data-skin'),
  };
};

export default toggleSwitchDriverFactory;
